<template>
  <div>
    <form action="#" @submit.prevent="loginWithTinybeans">
      <div class="form-field">
          <label for="emailAddress">Email<strong>*</strong></label>
          <input type="text" required id="emailAddress" name="emailAddress" v-model.lazy.trim="email" :disabled="authStatus.isRunning">
          <transition name="fade">
            <p v-if="error.email" class="error-message">{{error.email}}</p>
          </transition>
      </div>

      <div class="form-field password-fields">
          <label for="password">Password<strong>*</strong></label>
          <input :type="passwordFieldType" id="password" name="password" v-model.lazy.trim="password" :disabled="authStatus.isRunning">
          <span class="toggle-password" @click="togglePasswordVisibility">
            <svg v-if="!passwordVisible" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.78271 21L21.5327 3" stroke="#A6A6A6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8.96387 19.051C9.94668 19.3562 10.9708 19.5077 11.9999 19.5C16.0999 19.569 20.2579 16.687 22.8239 13.863C23.3937 13.2304 23.3937 12.2696 22.8239 11.637C21.8943 10.6172 20.8644 9.69355 19.7499 8.88" stroke="#A6A6A6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M14.4128 6.282C13.6238 6.08564 12.8129 5.99088 11.9998 6C7.96883 5.933 3.79983 8.752 1.17883 11.635C0.609011 12.2676 0.609011 13.2284 1.17883 13.861C1.97575 14.7334 2.84557 15.5363 3.77883 16.261" stroke="#A6A6A6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8.25 12.75C8.24973 11.7554 8.64474 10.8014 9.34806 10.0981C10.0514 9.39474 11.0054 8.99973 12 9" stroke="#A6A6A6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15.75 12.749V12.749C15.7503 13.7437 15.3553 14.6978 14.652 15.4013C13.9487 16.1048 12.9947 16.5 12 16.5" stroke="#A6A6A6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0001 5.251C7.96907 5.183 3.80007 8 1.17907 10.885C0.609255 11.5176 0.609255 12.4784 1.17907 13.111C3.74307 15.935 7.90007 18.817 12.0001 18.748C16.1001 18.817 20.2581 15.935 22.8241 13.111C23.3939 12.4784 23.3939 11.5176 22.8241 10.885C20.2001 8 16.0311 5.183 12.0001 5.251Z" stroke="#A6A6A6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M15.75 12C15.7494 14.0709 14.0703 15.7494 11.9993 15.749C9.9284 15.7486 8.24982 14.0696 8.25 11.9987C8.25018 9.92773 9.92906 8.249 12 8.249C12.9948 8.24874 13.9489 8.64388 14.6523 9.34741C15.3556 10.0509 15.7505 11.0052 15.75 12V12Z" stroke="#A6A6A6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <transition name="fade">
            <p v-if="error.password" class="error-message">{{error.password}}</p>
          </transition>
      </div>

      <div class="form-field__remember">
        <div>
          <input type="checkbox" name="rememberMe" id="rememberMe" v-model="rememberMe" :disabled="authStatus.isRunning">
          <label for="rememberMe" class='label--visible'>Remember me</label>
        </div>
        <div>
          <p class="forgot-text">
            <a href="#" @click="redirectToResetPassword()">I forgot my password</a>
          </p>
        </div>
      </div>

      <div>
        <transition name="fade">
          <p v-if="authStatus.hasFailed && authStatus.authSource === 'tinybeans'" class="error-message">
            {{authStatus.message}}
          </p>
        </transition>
        <button id="loginButton" type="submit" class='btn btn-login' :disabled="authStatus.isRunning">Log in</button>
      </div>
      <div id="g-recaptcha" style="margin: 8px auto;">
      </div>
    </form>
  </div>
</template>

<script>
import { authenticateWithTinybeans } from '@/helpers/Auth';
import { validateEmail } from '@/helpers/helpers';
import { mapGetters } from 'vuex';
import { redirectToResetPassword } from '@/helpers/helpersUsingStore';

export default {
  name: 'LoginForm',
  data: function() {
    return {
      email: '',
      password: '',
      rememberMe: false,
      passwordVisible: false,
      error: {
        email: '',
        password: '',
      }
    };
  },
  computed: {
    ...mapGetters([
      'authStatus',
    ]),
    passwordFieldType() {
      return this.passwordVisible ? 'text' : 'password';
    },
  },
  methods: {
    loginWithTinybeans: async function() {
      let hasErrors = false;

      [
        { fieldName: 'email', fieldValue: this.email, errorMsg: 'Email address is required' },
        { fieldName: 'password', fieldValue: this.password, errorMsg: 'Password is required' },
      ].forEach(({ fieldName, fieldValue, errorMsg}) => {
        if (!fieldValue) {
          this.error[fieldName] = errorMsg;
          hasErrors = true;
        }
      });

      if(!hasErrors) {
        this.error.email = '';
        this.error.password = '';

        const credentials = {
          username: this.email,
          password: this.password,
          rememberMe: this.rememberMe,
        };
        await authenticateWithTinybeans(credentials);
      }
    },
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
    redirectToResetPassword: redirectToResetPassword
  },
  watch: {
    email: function() {
      if(!validateEmail(this.email)) {
        this.error.email = 'Email address is invalid';
      } else {
        this.error.email = '';
      }
    },
    password: function() {
      if(this.password) {
        this.error.password = '';
      }
    }
  }
}
</script>

<style lang="sass">
  .section__form {
    .form-field {

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    input[type=text],
    input[type=password],
    input[type=email] {

      &:disabled {
        cursor: not-allowed;
      }
    }

    ::-webkit-input-placeholder { /* Edge */
      font-family: "houschka-rounded", Sans-serif;
      font-size: 15px;
      color: $boulder;
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
      font-family: "houschka-rounded", Sans-serif;
      font-size: 15px;
      color: $boulder;
    }

    ::placeholder {
      font-family: "houschka-rounded", Sans-serif;
      font-size: 15px;
      color: $boulder;
    }

  }

  .trickyField {
    width:100%;
    height:50px;
    background-color: lightgreen;
  }
</style>
